import { render, staticRenderFns } from "./ekko.footer.vue?vue&type=template&id=0a3fa003&scoped=true&"
import script from "./ekko.footer.vue?vue&type=script&lang=ts&"
export * from "./ekko.footer.vue?vue&type=script&lang=ts&"
import style0 from "./ekko.footer.vue?vue&type=style&index=0&id=0a3fa003&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3fa003",
  null
  
)

export default component.exports